import { Classes, Icon } from "@blueprintjs/core"
import StringInput from "components/Atoms/StringInput"
import CustomReactTable from "components/Templates/CustomReactTable"
import { useAllItemsInTripQuery } from "generated/graphql"
import React from "react"
import { useNavigate } from "react-router-dom"
import classNames from "utils/classNames"

const SellableItemsTable = ({ tripId }) => {
  const navigate = useNavigate()
  const { data: items } = useAllItemsInTripQuery({
    variables: { tripId },
    fetchPolicy: "network-only",
  })

  const COLUMNS = [
    {
      Header: "Item",
      accessor: "sellableItem",
      Cell({ value }) {
        return (
          <div
            className="flex items-center"
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate(`/d/ecom/dms/trip/${tripId}/item/${value.id}`)
            }}
          >
            <Icon
              className="ml-2"
              icon="media"
              iconSize={25}
              intent="success"
            />
            <div className="ml-3">
              <div className="vt-text-center">{value.name}</div>
              <div
                className={classNames(
                  "vt-text-left",
                  Classes.TEXT_MUTED,
                  Classes.TEXT_SMALL
                )}
              >
                {value.id}
              </div>
            </div>
          </div>
        )
      },
    },
    {
      minWidth: 40,
      Header: "Ordered",
      accessor: "requiredQuantity",
      Cell({ value }) {
        return (
          <>
            <div className="vt-text-center">{`${value}`}</div>
          </>
        )
      },
    },
    {
      minWidth: 50,
      Header: "Loaded",
      accessor: "despatchedQuantity",
      Cell({ value }) {
        return (
          <div className="vt-text-center">
            <StringInput type="number" value={value || 0} disabled={true} />
          </div>
        )
      },
    },
  ]

  return (
    <div>
      {items && (
        <CustomReactTable
          className="vt-dms-react-table"
          data={items?.siByBooking}
          columns={COLUMNS}
        />
      )}
    </div>
  )
}

export default SellableItemsTable
